/**
 * Types pour l'authentification
 * Partagés entre BackOffice et FrontOffice
 */

export type UserRole = 'super_admin' | 'admin' | 'commercial' | 'magasinier' | 'caissier' | 'comptable' | 'client' | 'gardien' | 'femme_menage' | 'cuisinier' | 'serveuse' | 'technicien';
export type PortalType = 'backoffice' | 'frontoffice';

export interface User {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  role: UserRole;
  siteId?: string;
  siteName?: string;
  enterpriseId?: string; // ID de l'entreprise (null pour super_admin)
  isEmailVerified: boolean;
  mustChangePassword: boolean;
  permissions: string[];
  createdAt: string;
  updatedAt: string;
}

export interface LoginRequest {
  email: string;
  password: string;
  portal: PortalType;
}

export interface AuthTokens {
  accessToken: string;
  refreshToken: string;
  expiresIn: number;
}

export interface LoginResponse {
  tokens: AuthTokens;
  user: User;
}

export interface RegisterRequest {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
}

export interface RegisterResponse {
  success: boolean;
  message: string;
  userId: string;
}

export interface ForgotPasswordRequest {
  email: string;
  portal?: PortalType;
}

export interface ForgotPasswordResponse {
  success: boolean;
  message: string;
}

export interface ResetPasswordRequest {
  token: string;
  password: string;
}

export interface ResetPasswordResponse {
  success: boolean;
  message: string;
}

export interface ChangePasswordRequest {
  currentPassword: string;
  newPassword: string;
}

export interface ChangePasswordResponse {
  success: boolean;
  message: string;
}

export interface VerifyEmailRequest {
  token: string;
}

export interface VerifyEmailResponse {
  success: boolean;
  message: string;
}

export interface RefreshTokenResponse {
  tokens: AuthTokens;
}

export interface TestUser {
  email: string;
  password: string;
  role: UserRole;
  name: string;
}

export const ROLE_LABELS: Record<UserRole, string> = {
  super_admin: 'Super Administrateur',
  admin: 'Administrateur',
  commercial: 'Commercial',
  magasinier: 'Magasinier',
  caissier: 'Caissier',
  comptable: 'Comptable',
  client: 'Client',
  gardien: 'Gardien',
  femme_menage: 'Femme de ménage',
  cuisinier: 'Cuisinier',
  serveuse: 'Serveuse',
  technicien: 'Technicien',
};

export const PORTAL_LABELS: Record<PortalType, string> = {
  backoffice: 'BackOffice',
  frontoffice: 'FrontOffice',
};

// Rôles autorisés par portail
// Note: gardien et femme_menage n'ont PAS accès au backoffice
export const PORTAL_ROLES: Record<PortalType, UserRole[]> = {
  backoffice: ['super_admin', 'admin', 'commercial', 'magasinier', 'caissier', 'comptable', 'cuisinier', 'serveuse', 'technicien'],
  frontoffice: ['client', 'super_admin', 'admin', 'commercial', 'magasinier', 'caissier', 'comptable', 'cuisinier', 'serveuse', 'technicien'],
};

// Rôles sans accès au backoffice (employés non-connectables)
export const NON_LOGIN_ROLES: UserRole[] = ['gardien', 'femme_menage'];
